import React from 'react'
import MicroFrontend from "../MicroFrontend"
import MicroFrontendContainer from './MicroFrontendContainer'

const MagnittBanner = ({ data }) => {
    return (
        <MicroFrontendContainer
            MicroFrontend={MicroFrontend}
            name="MagnittBannerWidget"
            data={data}
            skeletonId="magnittBannerWidgetSkeleton"
            className='magnitt-banner-container'
        />
    )
}

export default (MagnittBanner);
